import React from 'react'

import classnames from 'classnames'
import { useParams, useRouteMatch } from 'react-router-dom'

import { api } from '../api'
import { ChannelDetailsPanel } from './ChannelDetailsPanel'
import { ChannelMessages } from './ChannelMessages'

export const ChannelDetailsPage: React.FC = () => {
  const { channelId } = useParams<{ channelId: string }>()
  const isChannelDetails =
    useRouteMatch('/channels/:channelId/details')?.isExact === true

  const [
    channelDetails,
    setChannelDetails,
  ] = React.useState<Api_ChannelsDetails.RootObject>()

  React.useEffect(() => {
    setChannelDetails(undefined)
    api.getChannelDetails({ channelId }).then(setChannelDetails)
  }, [channelId])

  const onShouldRefetchChannel = React.useCallback(() => {
    return api.getChannelDetails({ channelId }).then(setChannelDetails)
  }, [channelId])

  if (!channelDetails || !channelDetails.channel) {
    return (
      <div className="column is-flex is-flex-direction-column mt-6 mr-4">
        <div className="loader is-loading" />
      </div>
    )
  }

  return (
    <>
      <ChannelMessages channelDetails={channelDetails} />
      <div
        className={classnames('column box is-one-quarter-tablet', {
          'is-hidden-mobile': !isChannelDetails,
        })}
        style={{
          backgroundColor: '#F4F4F4',
          flexFlow: 'column',
          overflowY: 'scroll',
        }}>
        <div className="py-4">
          <ChannelDetailsPanel
            channelDetails={channelDetails}
            onShouldRefetchChannel={onShouldRefetchChannel}
          />
        </div>
      </div>
    </>
  )
}
